var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Location Precise component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconLocationPrecise extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9995 1.10519C12.4137 1.10519 12.7495 1.44098 12.7495 1.85519V4.26249C16.444 4.61616 19.3836 7.55575 19.7373 11.2502H22.1445C22.5587 11.2502 22.8945 11.586 22.8945 12.0002C22.8945 12.4144 22.5587 12.7502 22.1445 12.7502H19.7373C19.3836 16.4447 16.444 19.3843 12.7495 19.738V22.1452C12.7495 22.5594 12.4137 22.8952 11.9995 22.8952C11.5853 22.8952 11.2495 22.5594 11.2495 22.1452V19.738C7.55505 19.3843 4.61546 16.4447 4.26179 12.7502H1.85449C1.44028 12.7502 1.10449 12.4144 1.10449 12.0002C1.10449 11.586 1.44028 11.2502 1.85449 11.2502H4.26179C4.61548 7.55577 7.55506 4.61619 11.2495 4.26249V1.85519C11.2495 1.44098 11.5853 1.10519 11.9995 1.10519ZM11.9995 5.72678C15.4615 5.72678 18.2685 8.53104 18.273 11.992L18.2729 12.0002L18.273 12.0085C18.2686 15.4667 15.466 18.2693 12.0078 18.2737L11.9995 18.2737L11.9913 18.2737C8.53034 18.2692 5.72607 15.4622 5.72607 12.0002C5.72607 8.5355 8.5348 5.72678 11.9995 5.72678ZM11.9996 10.4699C11.1544 10.4699 10.4692 11.1551 10.4692 12.0003C10.4692 12.8455 11.1544 13.5307 11.9996 13.5307C12.8448 13.5307 13.53 12.8455 13.53 12.0003C13.53 11.1551 12.8448 10.4699 11.9996 10.4699Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconLocationPrecise.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconLocationPrecise.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconLocationPrecise.prototype, "size", void 0);
if (customElements.get('cat-icon-location-precise') === undefined) {
    customElements.define('cat-icon-location-precise', BlocksIconLocationPrecise);
}
